<template>

    <!-- BEGIN Base Outer Element -->
    <!--<div id="main-playlists-view" class="h-full rounded-t-lg flex flex-row bg-theme-level4 items-stretch">-->
    <div id="main-playlists-view" class="h-full rounded-t-lg flex flex-row bg-theme-level4 items-stretch">

        <!-- BEGIN Left Column -->
        <div id="left-column" class="relative bg-theme-level4 w-3/5 rounded-tl-lg flex flex-col" style="min-width: 468px;">

            <span v-if="!(this.$root.shared.playerPayload==='')">

                <div id="player-container" class="pl-6 pt-6 pr-6">

                    <playlists-video-player :currentlocale="currentlocale"></playlists-video-player>

                </div>

                <div class="overflow-y-auto">

                    <div v-text="this.$root.shared.playerPayload.title"
                         class="text-2xl text-theme-main font-bold ml-6 mr-6 pt-2 pb-4 leading-tight border-b border-theme-level1"></div>

                    <!-- BEGIN Viz, Thumbs and some controls -->
                    <div class="border-b border-theme-level1 mr-6 ml-6 pr-2 py-2 text-theme-discrete flex flex-row justify-between items-center">

                        <div class="flex flex-row items-center justify-between">

                            <span class="text-sm"><span v-text="this.$root.shared.contentPlays"></span> {{ translate('playerview-views')}}</span>

                            <div class="ml-8 flex flex-row items-center">
                                <i v-if="isLikeable" class="material-icons mr-2 pl-1 cursor-pointer w-6 h-6 text-theme-discrete hover:text-theme-main" @click="updateLikes">thumb_up</i>
                                <i v-else class="material-icons mr-2 pl-1 w-6 h-6 text-theme-discrete">thumb_up</i>
                                <p class="mr-2 text-sm text-green-600" v-text="this.$root.shared.contentLikes"></p>
                                <i v-if="isDislikeable" class="material-icons ml-2 mr-2 pl-1 cursor-pointer w-6 h-6 text-theme-discrete hover:text-theme-main" @click="updateDislikes">thumb_down</i>
                                <i v-else class="material-icons ml-2 mr-2 pl-1 w-6 h-6 text-theme-discrete">thumb_down</i>
                                <p class="text-sm text-red-700" v-text="this.$root.shared.contentDislikes"></p>
                            </div>

                        </div>

                    </div>

                    <!-- BEGIN Abstract and Toggle switch -->
                    <div id="data-container" class="flex flew-row items-start mb-2 w-full px-4">

                        <div class="text-sm text-theme-discrete p-2 leading-normal" v-text="this.$root.shared.playerPayload.abstract"></div>

                        <i class="material-icons mr-2 ml-2 mt-2 transform text-theme-discrete transition-all duration-200 cursor-pointer bg-theme-level3 hover:bg-theme-level2 rounded-full" :class="{ 'rotate-90': !dataIsVisible }" style="font-size: 32px;" @click="toggleDataIsVisible">arrow_drop_down</i>

                    </div>

                    <div id="content-date" class="flex flex-row items-center text-sm text-theme-discrete mb-4 ml-6">
                        <i class="material-icons mr-2" style="font-size: 16px;">event_note</i>
                        <span class="flex-1">
                            <span>{{  translate('published-on') }}</span> <span v-text="this.$root.shared.playerPayload.publish_date.split(' ')[0]"></span>,
                            <span>{{  translate('at') }}</span> <span v-text="this.$root.shared.playerPayload.publish_date.split(' ')[1]"></span></span>
                    </div>

                    <!-- END Abstract and Toggle switch -->

                    <!-- BEGIN Toggleable Area -->
                    <div :class="{ 'hidden': !dataIsVisible }" class="flex flex-col px-6">

                        <div id="content-correspondent" class="mt-4">
                            <p class="text-theme-discrete text-xs pb-1">{{ translate('playerview-correspondent') }}</p>
                            <div v-if="this.$root.shared.playerCategories[5] !== ''" class="flex flex-row flex-wrap">
                                <span
                                    class="bg-theme-controls3 hover:bg-theme-controls2 cursor-pointer text-theme-control-label text-xs rounded-full px-3 py-1 mr-1 mt-1"
                                    v-text="this.$root.shared.playerCategories[5]" @click.stop="gotoCorrespondent">
                                </span>
                            </div>
                            <div v-else class="flex flex-row flex-wrap">
                                <p class="text-theme-muted text-xs">{{ translate('playerview-no-correspondent') }}</p>
                            </div>
                        </div>

                        <div id="content-pois" class="mt-4">
                            <p class="text-theme-discrete text-xs">{{ translate('playerview-pois') }}</p>
                            <div v-if="this.$root.shared.playerCategories[2].length !== 0" class="flex flex-row flex-wrap">
                                <span v-for="person in this.$root.shared.playerCategories[2]" v-if="person !== $root.shared.playerCategories[5]"
                                      class="hover:underline hover:text-theme-title cursor-pointer text-theme-main text-sm rounded py-1 mr-3 mt-1"
                                      v-text="person" @click.stop="gotoPoi(person)">
                                </span>
                            </div>
                            <div v-else class="flex flex-row flex-wrap">
                                <p class="text-theme-muted text-xs">{{ translate('playerview-no-poi') }}</p>
                            </div>
                        </div>

                        <div id="content-categories" class="mt-4">
                            <p class="text-theme-discrete text-xs pb-1">{{ translate('playerview-categories') }}</p>
                            <div class="flex flex-row flex-wrap">
                                <span v-for="this_category in this.$root.shared.playerCategories[0]"
                                      class="bg-theme-controls3 hover:bg-theme-controls2 cursor-pointer text-theme-control-label text-xs rounded-full px-3 py-1 mr-1 mt-1"
                                      v-text="this_category" @click.stop="gotoCategory(this_category)">
                                </span>
                            </div>
                        </div>

                        <div id="content-subcategories" class="mt-4">
                            <p class="text-theme-discrete text-xs pb-1">{{ translate('playerview-subcategories') }}</p>
                            <div v-if="this.$root.shared.playerCategories[3].length !== 0" class="flex flex-row flex-wrap">
                                <span v-for="this_subcategory in this.$root.shared.playerCategories[3]"
                                      class="bg-theme-controls3 hover:bg-theme-controls2 cursor-pointer text-theme-control-label text-xs rounded-full px-3 py-1 mr-1 mt-1"
                                      v-text="this_subcategory" @click.stop="gotoSubCategory(this_subcategory)">
                                </span>
                            </div>
                            <div v-else class="flex flex-row flex-wrap">
                                <p class="text-theme-muted text-xs">{{ translate('playerview-no-subcat') }}</p>
                            </div>
                        </div>

                        <div id="content-countries" class="mt-4">
                            <p class="text-theme-discrete text-xs pb-1">{{ translate('playerview-countries') }}</p>
                            <div v-if="this.$root.shared.playerCategories[4].length !== 0" class="flex flex-row flex-wrap">
                                <span v-for="country in this.$root.shared.playerCategories[4]"
                                      class="bg-theme-copy4 hover:bg-theme-copy3 cursor-pointer text-theme-control-label text-xs rounded px-3 py-1 mr-1 mt-1"
                                      v-text="country" @click.stop="gotoCountry(country)">
                                </span>
                            </div>
                            <div v-else class="flex flex-row flex-wrap">
                                <p class="text-theme-muted text-xs">{{ translate('playerview-no-country') }}</p>
                            </div>
                        </div>

                        <div id="content-tags" class="mt-4">
                            <p class="text-theme-discrete text-xs pb-1">{{ translate('playerview-tags') }}</p>
                            <div v-if="this.$root.shared.playerCategories[1].length !== 0" class="flex flex-row flex-wrap">
                                <span v-for="tag in this.$root.shared.playerCategories[1]"
                                      class="bg-theme-copy4 hover:bg-theme-copy3 cursor-pointer text-theme-control-label text-xs rounded px-3 py-1 mr-1 mt-1"
                                      v-text="tag" @click.stop="gotoTag(tag)">
                                </span>
                            </div>
                            <div v-else class="flex flex-row flex-wrap">
                                <p class="text-theme-muted text-xs">{{ translate('playerview-no-tag') }}</p>
                            </div>
                        </div>

                    </div>
                    <!-- END Toggleable Area -->

                    <div class="border-b border-theme-level1 mr-6 ml-6 pr-2 py-2"></div>

                    <div id="comments-container" class="pb-24 text-theme-muted text-sm leading-normal mt-4">
                        <comments-component :language="currentlocale" :content_id="this.$root.shared.playerPayload.id"></comments-component>
                    </div>

                </div>

            </span>

        </div>
        <!-- END Left Column -->

        <!-- BEGIN Right Column -->
        <div id="right-column" class="bg-theme-level2 w-2/5 overflow-y-auto rounded-tr-lg overflow-hidden" style="min-width: 312px;">

            <!-- BEGIN CLOSE BUTTON -->
            <div class="absolute rounded-tr-lg" style="top: 0; right: 0;">
                <i class="material-icons pt-2 pr-2 text-theme-discrete hover:text-theme-main cursor-pointer" @click="closePlaylistView">highlight_off</i>
            </div>
            <!-- END CLOSE BUTTON -->

            <span class="ml-6 mr-6 pt-2 pb-4 border-b border-theme-level1 mt-2 flex flex-row items-center">

                <button v-if="this.$root.shared.isWatchLaterEnabled" class="text-base bg-theme-controls3 text-theme-control-label rounded-lg px-4 w-1/2 h-10 mt-4 mr-2 cursor-default">
                    {{ translate('watch-later') }}
                </button>
                <button v-else class="text-base hover:bg-theme-controls3 hover:text-theme-control-label text-theme-main rounded-lg px-4 w-1/2 h-10 mt-4 mr-2 cursor-pointer"
                        @click="showWatchLaterView">
                    {{ translate('watch-later') }}
                </button>

                <button v-if="!this.$root.shared.isWatchLaterEnabled" class="text-base bg-theme-controls3 text-theme-control-label rounded-lg px-4 w-1/2 h-10 mt-4 mr-2 cursor-default">
                    {{ translate('playlists') }}
                </button>
                <button v-else class="text-base hover:bg-theme-controls3 hover:text-theme-control-label text-theme-main rounded-lg px-4 w-1/2 h-10 mt-4 mr-2 cursor-pointer"
                        @click="showPlaylistsView">
                    {{ translate('playlists') }}
                </button>

            </span>

            <!-- BEGIN Display Area for the Watch Later content -->
            <div v-if="this.$root.shared.isWatchLaterEnabled" class="p-6 text-theme-main mb-12">

                <p class="mb-6 leading-tight text-sm">
                    {{ translate('watch-later-description') }}
                </p>

                <ul>

                    <template v-for="(item, index) in watchLaterList">

                        <watch-later-item
                            :key="index"
                            :currentlocale="currentlocale"
                            :item="item"
                            :thumbnail="regularThumbnail(item)"
                            :legacy_thumbnail="legacyThumbnail(item)"
                            :default_thumbnail="default_thumbnail"
                        >
                        </watch-later-item>

                    </template>

                </ul>

                <p v-if="!(watchLaterList.length > 0)" class="mb-6 text-theme-title font-bold">
                    {{ translate('playlist-empty') }}
                </p>

            </div>
            <!-- END Display Area for the Watch Later content -->

            <!-- BEGIN Display Area for the Playlists content -->
            <div v-if="!this.$root.shared.isWatchLaterEnabled" class="p-6 text-theme-main">

                <p class="mb-6 leading-tight text-sm">
                    {{ translate('playlists-description') }}
                </p>

                <select class="form-select w-full bg-theme-level4 text-theme-main" name="playlistSelector" id="playlistSelector" v-model="selectedPlaylistId" @input="playlistWasSelected">
                    <option v-for="item in userPlayLists" :value="item.id">{{ item.name }}</option>
                </select>

                <span v-if="!(userPlayLists.length > 0)">
                    <p class="mb-6 mt-6 text-theme-title font-bold">
                        {{ translate('playlists-nolist') }}
                    </p>
                </span>

                <div v-if="playlistItems.length > 0" class="mb-24 mt-6">

                    <ul>

                        <template v-for="(item, index) in playlistItems">

                            <user-list-item
                                :key="index"
                                :currentlocale="currentlocale"
                                :item="item"
                                :thumbnail="regularThumbnail(item)"
                                :legacy_thumbnail="legacyThumbnail(item)"
                                :default_thumbnail="default_thumbnail"
                                :item_playlist="selectedPlaylistId"
                            >
                            </user-list-item>

                        </template>

                    </ul>

                </div>
                <div v-else>

                    <p class="mb-6 mt-6 text-theme-title font-bold">
                        {{ translate('playlist-empty') }}
                    </p>

                </div>

            </div>
            <!-- END Display Area for the Playlists content -->

        </div>
        <!-- END Right Column -->

        <flash-message :position="'right top'" style="z-index: 999999999; pointer-events: none;" class="p-6"></flash-message>

    </div>
    <!-- END Base Outer Element -->

</template>

<script>

    import vSelect from 'vue-select';

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        components: {

            vSelect

        },

        props: [

            'currentlocale',
            'baseurl',
            'default_thumbnail',
            'current_user'

        ],

        data() {

            return {

                isLikeable: true,
                isDislikeable: true,

                dataIsVisible: false,

                shareableLinkPanelVisible: false,

                copy_label: this.translate('copy'),
                shareableLinkWasCopied: false,
                shareableLinkHadError: false,

                ENV_CloudFront_Legacy_DNS_Name: process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME,
                ENV_CloudFront_DNS_Name: process.env.MIX_CLOUDFRONT_DNSNAME,
                ENV_CloudFront_Legacy_Thumbnails: process.env.MIX_LEGACY_THUMBNAILS_CLOUDFRONT_DNSNAME,

                watchLaterList: this.$root.shared.userWatchLaterList ? this.$root.shared.userWatchLaterList.contents : '',
                userPlayLists: this.$root.shared.userPlaylistsCollection,

                /*selectedPlaylistId: this.$root.shared.userPlaylistsCollection.length > 0 ? this.$root.shared.userPlaylistsCollection[0].id : '',*/
                selectedPlaylistId: this.$root.shared.preselectedPlaylist ? this.$root.shared.preselectedPlaylist.id : '',

                playlistItems: ''

            }

        },

        computed: {

            thePlaylists() {

                // let userPlayLists = this.$root.shared.userPlaylistsCollection
                return this.userPlayLists.map(playlist => { return { label: playlist.name, id: playlist.id } });

            },

            commentsUrl() {

                return this.baseurl + '/' + this.$root.shared.playerPayload.id;

            },

            shareableLinkCode() {

                return 'https://' + window.location.hostname + '/' + this.currentlocale + '/content/' + this.$root.shared.playerPayload.id;

            },

        },

        methods: {

            regularThumbnail(item) {

                return this.ENV_CloudFront_DNS_Name + item.thumbnail_url;

            },

            legacyThumbnail(item) {

                return this.ENV_CloudFront_Legacy_Thumbnails + item.thumbnail_url;

            },

            showWatchLaterView() {

                /*this.$root.shared.isWatchLaterEnabled = true*/
                /*let userId = window.Laravel.user.id
                Event.fire('showPlaylistsView', { language: this.currentlocale, data: { userId: userId, isWatchLater: true } });*/
                this.$root.shared.playerPayload = ''
                Event.fire('showPlaylistsView', { language: this.currentlocale, data: { userId: this.current_user, isWatchLater: true } })
            },

            showPlaylistsView() {

                /*this.$root.shared.isWatchLaterEnabled = false*/
                /*let userId = window.Laravel.user.id
                Event.fire('showPlaylistsView', { language: this.currentlocale, data: { userId: userId, isWatchLater: false } });*/
                this.$root.shared.playerPayload = ''
                Event.fire('showPlaylistsView', { language: this.currentlocale, data: { userId: this.current_user, isWatchLater: false } })

            },

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            toggleDataIsVisible() {
                this.dataIsVisible = !this.dataIsVisible
            },

            updateLikes() {

                if(Laravel.user) {

                    axios.get('/' + this.currentlocale + '/content/stats/add-like/' + this.$root.shared.playerPayload.id)
                        .then(response => {

                            this.$root.shared.contentLikes = JSON.stringify(response.data);
                            this.isLikeable = false;
                            this.isDislikeable = false;

                            this.flashMessage.success({
                                title: '',
                                message: 'Este Contenido se ha agregado a su Lista "Me Gusta"',
                                blockClass: 'p-6',
                                x: 25,
                                y: 250,
                                time: 3000
                            });
                        })
                        .catch(error => {
                            // alert('ERROR: ' + error);
                        });

                } else {

                    this.flashMessage.info({
                        title: '',
                        message: 'Para poder hacer "Me Gusta" o "No me Gusta" en el contenido, debe tener su sesión iniciada.',
                        blockClass: 'p-6',
                        x: 25,
                        y: 250,
                        time: 4000
                    });

                }
            },

            updateDislikes() {

                if(Laravel.user) {

                    axios.get('/' + this.currentlocale + '/content/stats/add-dislike/' + this.$root.shared.playerPayload.id)
                        .then(response => {

                            this.$root.shared.contentDislikes = JSON.stringify(response.data);
                            this.isDislikeable = false;
                            this.isLikeable = false;

                            this.flashMessage.success({
                                title: '',
                                message: 'Este Contenido ha sido marcado como "No me Gusta"',
                                blockClass: 'p-6',
                                x: 25,
                                y: 250,
                                time: 3000
                            });
                        })
                        .catch(error => {
                            // alert('ERROR: ' + error);
                        });

                } else {
                    this.flashMessage.info({
                        title: '',
                        message: 'Para poder hacer "Me Gusta" o "No me Gusta" en el contenido, debe tener su sesión iniciada.',
                        blockClass: 'p-6',
                        x: 25,
                        y: 250,
                        time: 4000
                    });
                }
            },

            closePlaylistView() {
                /*console.log('Hiding the player...');*/
                Event.fire('hidePlaylistView');
            },

            getShareableLink() {
                this.shareableLinkPanelVisible=true;
            },

            setCopyLabelOk() {
                this.copy_label = this.translate('copied');
            },

            setCopyLabelError() {
                this.copy_label = 'Error!';
            },

            copyLinkToClipboard() {

                this.$copyText(this.shareableLinkCode).then((e) => {
                    this.setCopyLabelOk();
                    this.shareableLinkWasCopied=true;
                    /*console.log(e);*/
                }, (e) => {
                    this.setCopyLabelError();
                    this.shareableLinkHadError=true;
                    /*console.log(e)*/
                })
            },

            playlistWasSelected(value) {

                /*console.log('Selected Playlist: ')*/
                /*console.log(JSON.stringify(value.target.value))*/
                this.playlistItems = ''
                this.selectedPlaylistId = value.target.value
                /*console.log(this.selectedPlaylistId)*/

                this.getPlaylistContent(this.selectedPlaylistId)

            },

            getPlaylistContent(playlistId) {

                /*console.log('Getting items for Playlist: ' + playlistId)*/

                axios.get('/' + this.currentlocale + '/playlists/get/' + playlistId)
                    .then((response) => {

                        this.playlistItems = response.data

                        if(this.playlistItems.length > 0) {
                            /*console.log('This one has some!')*/
                            this.$root.shared.playerPayload = this.playlistItems[0]
                        }

                    })
                    .catch((error) => {
                        console.log('ERROR trying to get the Content for the Playlist with ID ' + playlistId + ': ' + error)
                    })

            }

        },

        mounted() {

            if(!this.$root.shared.isWatchLaterEnabled) {

                /*console.log(this.$root.shared.userPlaylistsCollection)*/
                /*console.log('Since it\'s not Watch Later, loading PLaylist: ' + this.$root.shared.preselectedPlaylist.id + ' - ' + this.$root.shared.preselectedPlaylist.name)*/

                this.selectedPlaylistId = this.$root.shared.preselectedPlaylist.id

                this.getPlaylistContent(this.selectedPlaylistId);

            }

        }

    }

</script>
